import { Builder } from '@builder.io/react';
import {Typography} from '@material-ui/core'

Builder.registerComponent(Typography, {
  name: 'Typography',
  // Optionally give a custom icon (image url - ideally a black on transparent bg svg or png)
  // image:'https://image-icon.svg',
  inputs: [
    {
      name: 'children',
      type: 'longText',
      defaultValue: 'Some text here'
    },
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'inherit',
      enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']
    },
    {
      name: 'color',
      type: 'string',
      defaultValue: 'initial',
      enum: ['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']
    },
    {
      name: 'component',
      type: 'string',
    },
  ]
});
